<template>
  <transition name="fade">
    <button v-scroll-to="'body'" class="scroll-top" v-if="scrollTopShown">
      <img src="@/assets/scroll-top.png" alt="">
    </button>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      scrollTopShown: false,
    };
  },
  methods: {
    handleScroll() {
      const scrolled = window.scrollY;
      const heroHeight = document.querySelector('.section--hero').offsetHeight || window.innerHeight;
      if (scrolled > heroHeight) {
        this.scrollTopShown = true;
      } else {
        this.scrollTopShown = false;
      }
    },
  },
  mounted() {
    window.addEventListener('resize', this.getWindowWidth);
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowWidth);
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.scroll-top {
  position: fixed;
  bottom: 50px;
  right: 50px;
  z-index: 3;
}
</style>



// WEBPACK FOOTER //
// src/components/ScrollTop.vue